import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        container: {
            height: 560,
        },
    }
})

export default useStyles
